/* eslint-disable */

<template>
  <div id="app">
    <NavBar />
    <div id="view-container">
      <fade-transition mode="out-in">
        <router-view />
      </fade-transition>
    </div>
    <div class="myF"></div>
    <side-tabs />
    <Footer />
  </div>
</template>

<script>
import NavBar from "@/components/NavBar";
import FadeTransition from "@/components/FadeTransition";
import Footer from "@/components/Footer";
import SideTabs from "./components/SideTabs.vue";

export default {
  name: "App",
  components: {
    NavBar,
    Footer,
    FadeTransition,
    SideTabs,
  },
  data() {
    return {};
  },
  created() {
    document.title = "ChronoPress";
  },
  mounted() {},
  methods: {},
};
</script>

<style>
:root {
  --cold_silver: #979797;
  --white_grey: #d5d6d1;
  --dark_silver: #848484;
  --grey_dark1: #595959;
  --grey_dark2: #4b4b4b;
  --grey_black: #292929;
  --grey_alpha_old: rgba(179, 180, 174, 0.7);
  --grey_alpha: rgba(179, 179, 179, 0.7);
  --dark_alpha: rgba(51, 51, 51, 0.7);
  --white_alpha: rgba(255, 255, 255, 1);
  --orange: #e59526;
}
.vue-input-tag-wrapper .input-tag {
  color: white !important;
  background-color: #5b5b5b !important;
  border-color: var(--orange) !important;
  border-radius: 8px !important;
}
.vue-input-tag-wrapper .input-tag .remove {
  color: var(--orange) !important;
}
.filters .vue-input-tag-wrapper .input-tag {
  color: white !important;
  background-color: #5b5b5b !important;
  border-color: var(--orange) !important;
  border-radius: 8px !important;
}
.col-form-label {
  font-weight: bold;
}
.button-80 {
  width: 80% !important;
  float: left !important;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
.button-20 {
  width: 20% !important;
  float: left !important;
  border-top-left-radius: 0 !important;
  border-bottom-left-radius: 0 !important;
}
html {
  background-color: #292929;
}
body {
  z-index: -1;
  background-color: var(--cold_silver);
  margin: 0;
  padding: 0;
  background-color: rgba(92, 148, 144, 0);
}
a.router-link-active {
  text-decoration: none !important;
  transition: all 0.3s ease 100ms !important;
  padding-bottom: 2px !important;
}
a.router-link-active:hover {
  text-decoration: none !important;
  font-size: 20px !important;
  transition: all 0.3s ease 100ms !important;
  padding-bottom: 4px !important;
}
#app {
  height: fit-content;
  margin: 0;
  padding: 0;
  font-family: "Jost", sans-serif !important;
}
.justify {
  text-align: justify;
  text-justify: inter-word;
}
#view-container {
  height: fit-content;
  justify-content: center;
  overflow: unset;
  background-image: url("assets/images/pattern2.jpg");
  margin-top: 60px;
}
.box-container-form {
  background-color: rgba(255, 255, 255, 0.5);
}
.content-container {
  height: auto;
}
input,
.input-group-text,
.form-group,
.multiselect {
  z-index: 0;
}
.component-container {
  display: flex;
  padding: 10px;
  height: 100%;
  width: 100%;
  text-align: center;
}

.box-container {
  width: 100%;
  margin: auto;
  display: flex;
  padding: 1vw;
  border-radius: 15px;
  background-color: rgba(255, 255, 255, 0.9) !important;
  box-shadow: 0 0 15px #0f0f0f99;
  max-width: 700px;
}
.multiselect {
  max-width: 100%;
}
.multi_filter {
  max-width: 100%;
}
.filters-content.div.multiselect {
  max-width: 500px;
}
.box-container-form {
  width: 100%;
  float: left;
  margin: auto;
  display: flex;
}

.box-container-result {
  width: 100%;
  float: left;
  margin: auto;
  display: flex;
}

.push {
  height: 50px;
}

.content-container {
  height: 100%;
  width: 100%;
  padding: 1vw;
  right: 0;
  left: 0;
  justify-content: center;
}

.carousel {
  height: 66px;
  width: 100%;
  position: absolute;
  z-index: +1;
  display: inline;
  margin-top: -3px;
}

.view-content {
  height: 100%;
  height: calc(100vh - 60px);
  display: flex;
}

label,
legend {
  color: var(--grey_black);
}

:focus {
  outline: none !important;
}

.submit-button,
.submit-button:focus {
  background-color: var(--grey_black) !important;
  color: var(--orange);
  outline: 0;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border: none;
  text-transform: uppercase;
}

.submit-button:focus:active,
.submit-button:active:focus,
.submit-button:focus.active,
.submit-button:active.focus,
.submit-button:hover {
  color: var(--grey_dark1);
  background-color: var(--white_grey) !important;
}

.submit-button:disabled {
  background-color: var(--grey_dark1) !important;
}

.submit-button:active {
  background-color: var(--white_grey) !important;
  box-shadow: 0 0 5px var(--grey_dark1) !important;
  border: 1px solid var(--grey_dark1) !important;
}

.filter-button,
.filter-button:focus {
  background-color: var(--grey_dark1) !important;
  outline: 0;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border: none;
  text-transform: uppercase;
  color: white;
}

.filter-button:focus:active,
.filter-button:active:focus,
.filter-button:focus.active,
.filter-button:active.focus,
.filter-button:hover {
  background-color: var(--white_grey) !important;
  color: var(--grey_dark1);
}

.filter-button:disabled {
  background-color: var(--grey_black) !important;
}

.filter-button:active {
  background-color: var(--white_grey) !important;
  box-shadow: 0 0 5px var(--grey_dark1) !important;
  border: 1px solid var(--grey_dark1) !important;
  color: var(--grey_dark1);
}

.trigger-button,
.trigger-button:focus {
  width: 100%;
  background-color: var(--white_grey) !important;
  outline: 0;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
  border: 2px solid var(--grey_black) !important;
  text-transform: uppercase;
  color: var(--grey_black) !important;
  margin: 2px;
}
.active .trigger-button-ico:before {
  content: "✔ " !important;
}
.trigger-button-ico:before {
  content: "✘ " !important;
}
.trigger-button:hover {
  background-color: var(--grey_black) !important;
  color: var(--white_grey) !important;
}

.trigger-button.active:hover {
  background-color: var(--grey_black) !important;
  color: var(--white_grey) !important;
  text-decoration: inherit;
}
.trigger-button:disabled {
  background-color: var(--grey_black) !important;
  text-decoration: inherit;
  font-weight: 900 !important;
}
.trigger-button.active {
  background-color: var(--grey_dark2) !important;
  color: var(--white_grey) !important;
  text-decoration: inherit;
}
.trigger-button.active:focus {
  background-color: var(--grey_dark2) !important;
  color: var(--white_grey) !important;
  text-decoration: inherit;
}
input[type="text"].form-input-default:focus,
textarea:focus,
select:focus,
input[type="range"]:focus {
  box-shadow: 0 0 5px var(--grey_dark1) !important;
  border: 1px solid var(--grey_dark1) !important;
}
.input-group-prepend::before {
  background-color: var(--grey_dark1);
}
.nav-link {
  text-align: center;
}
.dropdown-item {
  text-align: center;
}
.dropdown-button {
  justify-content: center;
}
.btn-none {
  visibility: hidden;
}
.modal-header {
  background-color: var(--grey_black);
  text-transform: uppercase;
  color: var(--white_grey);
}
li.page-item a {
  background-color: var(--white_grey);
  color: var(--grey_black);
}
li.page-item:hover a {
  background-color: var(--white_grey);
  color: var(--grey_dark1);
}
li.page-item.active a {
  background-color: var(--grey_black) !important;
  color: var(--white_grey);
  box-shadow: 0 0 0 var(--grey_black) !important;
  border: 1px solid var(--grey_black) !important;
}
li.page-item:active a {
  background-color: var(--grey_black);
  color: var(--white_grey);
  box-shadow: 0 0 0 var(--grey_black) !important;
  border: 1px solid var(--grey_black) !important;
}
input[title]:hover:after {
  background-color: transparent !important;
}

.view-arrow-left {
  width: 66px;
  height: 66px;
  float: left;
  position: relative;
  z-index: auto;
  transform: translateY(-60px);
}
.view-arrow-right {
  width: 66px;
  height: 66px;
  right: 0;
  position: relative;
  z-index: auto;
  float: right;
  transform: translateY(-60px);
}
.view-arrow-left img {
  position: absolute;
  width: 80%;
  height: 80%;
  margin: 10%;
  opacity: 0.2;
  filter: alpha(opacity=20);
}
.view-arrow-right img {
  position: absolute;
  width: 80%;
  height: 80%;
  margin: 10%;
  opacity: 0.2;
  filter: alpha(opacity=20);
}
.view-arrow-right:hover img {
  opacity: 0.8;
  filter: alpha(opacity=80);
  width: 100%;
  height: 100%;
  margin: 0;
  right: 0;
  transition: all 0.3s ease 0s;
}
.view-arrow-left:hover img {
  opacity: 0.8;
  filter: alpha(opacity=80);
  width: 100%;
  height: 100%;
  margin: 0;
  left: 0;
  transition: all 0.3s ease 0s;
}
span.multiselect__tag {
  background-color: var(--grey_dark2);
}
span.multiselect__tag-icon {
  background-color: var(--grey_dark2);
}
i.multiselect__tag-icon:hover {
  background-color: var(--grey_dark1);
  box-shadow: 0 0 5px var(--grey_dark1);
}
i.multiselect__tag-icon:after {
  color: var(--orange);
}
.multiselect__active {
  box-shadow: 0 0 0 var(--grey_black) !important;
  border: 0px solid var(--grey_black) !important;
}
.multiselect__option--highlight {
  background: var(--grey_black) !important;
  outline: none;
  color: white;
}
.multiselect__option--highlight:after {
  content: attr(data-select);
  background: var(--grey_black) !important;
  color: white;
}
.multiselect__option--selected {
  background: var(--white_grey);
  color: var(--grey_black);
  font-weight: bold;
}
.multiselect__option--selected:after {
  content: attr(data-selected);
  color: silver;
}
.multiselect__option--selected.multiselect__option--highlight {
  background: var(--grey_dark1) !important;
  color: #fff;
}
.multiselect__option--selected.multiselect__option--highlight:after {
  background: var(--grey_dark1) !important;
  content: attr(data-deselect);
  color: #fff;
}

@media only screen and (min-width: 768px) {
  #view-container {
    height: calc(100vh - 120px) !important;
    display: flex;
    display: -webkit-flex; /* Safari */
    -webkit-flex-direction: row-reverse; /* Safari 6.1+ */
    flex-direction: row;
    justify-content: center;
    overflow: visible;
    margin-top: 60px;
  }
  .component-container {
    width: 100%;
    text-align: center;
  }

  .box-container {
    background-color: var(--grey_alpha);
    overflow: auto;
    width: auto;
    min-width: 500px;
    display: inline-block;
    margin-left: auto;
    margin-right: auto;
    margin-top: 2rem;
  }

  .box-container-form {
    overflow: auto;
    width: 30%;
    height: 100%;
    display: inline-block;
  }

  .box-container-result {
    overflow: auto;
    width: 70%;
    height: 100%;
    display: inline-block;
  }

  .view-content {
    height: calc(100vh - 120px);
    display: flex;
  }

  .content-container {
    height: 100%; /* footer overflow */
    margin-bottom: inherit;
  }

  .form-input-default {
    height: 30px;
  }

  /* Special styling for WebKit/Blink */
  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    height: 16px;
    width: 16px;
    background: var(--grey_black) !important;
    cursor: pointer;
  }

  /* All the same stuff for Firefox */
  input[type="range"]::-moz-range-thumb {
    height: 16px;
    width: 16px;
    background: var(--grey_black) !important;
    cursor: pointer;
  }

  /* All the same stuff for IE */
  input[type="range"]::-ms-thumb {
    height: 16px;
    width: 16px;
    background: var(--grey_dark2) !important;
    cursor: pointer;
  }

  input[type="range"],
  .input-group-prepend {
    height: 30px !important;
  }

  select {
    height: 30px !important;
    padding: 2px 6px !important;
  }

  .trigger-button {
    width: 45% !important;
  }

  .dropdown-item {
    text-align: left;
  }
}
.spinner-container {
  position: relative;
  width: 100%;
  height: 100%;
}
.spinner {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 50%;
  height: 30%;
  margin: auto;
}
</style>
<style>
@import url("https://use.fontawesome.com/releases/v5.9.0/css/all.css");
@import url("https://fonts.googleapis.com/css2?family=Jost:wght@300&display=swap");
</style>



// WEBPACK FOOTER //
// src/App.vue